const EyeIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 16 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 10.5c4.418 0 8-5 8-5s-3.582-5-8-5-8 5-8 5 3.582 5 8 5zm0-1a4 4 0 100-8 4 4 0 000 8z"
        fill="currentColor"
      />
      <path
        d="M9.998 5.415a1.5 1.5 0 01-1.914-1.914 2 2 0 101.914 1.914z"
        fill="currentColor"
      />
    </svg>
  )
}

export default EyeIcon
